import {useResizeListener} from "../../listeners/SystemResizeListener";
import {useState} from "react";
import GlossaryLayout from "../../components/layouts/glossaryScreen/GlossaryLayout";
import GlossaryContentLayout from "../../components/layouts/glossaryScreen/GlossaryContentLayout";
import GlossaryContent from "../../components/others/glossaryScreen/GlossaryContent";
import {kHomeTexts} from "../../constants/texts";
import SystemScreenTopBar from "../../components/bars/SystemScreenTopBar";
import SystemAppDrawer from "../../components/others/SystemAppDrawer";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";

export default function GlossaryScreen() {
    // Used in index.js by the router as an entry point
    // for compulsory legal texts, in tablet and desktop modes

    // PROPERTIES
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return (
        <div className={"animate-appearSlow overflow-auto w-full h-[100svh] flex flex-col justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Glossaire')}</title>
                <meta name="description"
                      content="Liste des termes mathématiques à connaître au collège." />
            </Helmet>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={kHomeTexts.navGlossary}
                               openDrawer={openDrawer} />
            <GlossaryLayout>
                <GlossaryContentLayout>
                    <GlossaryContent />
                </GlossaryContentLayout>
            </GlossaryLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }

}